import { useMutation } from "@tanstack/react-query";
import { SendSMS } from "../Api";

export const useSendSMSMutation = () => {
  return useMutation({
    mutationFn: (payload: Parameters<typeof SendSMS>[0]) =>
      SendSMS(payload),
  });
};
